export default [
    {
        path: "/share",
        name: "share",
        meta: {
            title: "分享",
            norpermission: true
        },
        component: () => import("@/views/share/share.vue"),
        children: [
            {
                path: "share_sheet",
                name: "share_sheet",
                meta: {
                    title: "工作表",
                    norpermission: true
                },
                component: () => import("@/views/share/share_sheet.vue")
            },
            {
                path: "share_dashboard",
                name: "share_dashboard",
                meta: {
                    title: "仪表盘",
                    norpermission: true
                },
                component: () => import("@/views/share/share_dashboard.vue")
            },
            {
                path: "shareSuccess/:href",
                name: "shareSuccess",
                meta: {
                    title: "工作表",
                    norpermission: true
                },
                component: () => import("@/views/share/shareSuccess.vue")
            }

        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/share.js